import React from 'react';
import { useSectionContext } from './SectionContext';
import { Breadcrumbs, BreadcrumbsProps } from './Breadcrumbs';

export type SectionBreadcrumbsProps<T = any> = Omit<
  BreadcrumbsProps<T>,
  'basePath'
>;

export const SectionBreadcrumbs = <T = any,>(
  props: SectionBreadcrumbsProps<T>
) => {
  const { basePath } = useSectionContext();
  return <Breadcrumbs<T> {...props} basePath={basePath} />;
};
